import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ICoin, ICoinSearch } from "./types/_coin";
import { PaginationResponse, ResponseData } from "./types/_public";
import { ICategory } from "./types/_category";
const api = new APIClient();

const path = "/coins";
const coinApi = {
  coins(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICoinSearch[]> & PaginationResponse, any>> {
    const url = `${path}/candles`;
    return api.get(url, params);
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `masters/categories`;
    return api.get(url, params);
  },
  allCoins(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICoin[]> & PaginationResponse, any>> {
    const url = `/masters/coins`;
    return api.get(url, params);
  },
};
export default coinApi;
